import { configConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  request: null,
  response: null,
  error: null
};

export const viewConfig = (state = initialState, action) => {
  switch (action.type) {
    case configConstants.VIEW_CONFIG_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        request: action.id,
        response: null,
        error: null
      };
    case configConstants.VIEW_CONFIG_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case configConstants.VIEW_CONFIG_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        response: null,
        error: action.error
      };
    case configConstants.VIEW_CONFIG_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
